module.exports = __webpack_public_path__ + "img/考试报名系统.6a5293a5.png";